import { IconCurrencyCircleDollar, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import {
  CONNECTOR,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { messages } from './messages'

type Props = {
  onEdit: () => void
  onRemove: () => void
  discount: number
}

export function DiscountRule(props: Props) {
  const { $t } = useIntl()
  const { formatPercentual } = useNumbers()
  const { onEdit, onRemove, discount } = props

  return (
    <Rule onClick={onEdit} connector={CONNECTOR.NONE}>
      <RuleIcon>
        <IconCurrencyCircleDollar />
      </RuleIcon>

      <RuleDescription>
        {$t(messages.rule.discount.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
        })}
      </RuleDescription>

      <RuleContent>
        <Tag>{formatPercentual(discount)}</Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
